"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _Box = _interopRequireDefault(require("../Box"));

var _once = _interopRequireDefault(require("./once"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ANIMATION_DURATION = 600;

var _StyledBox = (0, _styledComponents["default"])(_Box["default"]).withConfig({
  displayName: "Fader___StyledBox",
  componentId: "sc-1id1xr5-0"
})(["transition-property:opacity;transition-duration:", "s;opacity:", ";"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
});

var Fader = function Fader(_ref) {
  var visible = _ref.visible,
      onFade = _ref.onFade,
      props = _objectWithoutProperties(_ref, ["visible", "onFade"]);

  var ref = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    var el = ref.current;
    var transitionEventKey = whichTransitionEndEvent();
    var onFadeOnce = (0, _once["default"])(onFade);

    var handleTransitionEnd = function handleTransitionEnd() {
      var justFaded = window.getComputedStyle(el).opacity === "0";
      if (justFaded) onFadeOnce();
    };

    el.addEventListener(transitionEventKey, handleTransitionEnd);
    return function () {
      return el.removeEventListener(transitionEventKey, handleTransitionEnd);
    };
  }, []);
  return _react["default"].createElement(_StyledBox, _extends({}, props, {
    ref: ref,
    _css: ANIMATION_DURATION / 1000,
    _css2: visible ? 1 : 0
  }));
};

Fader.propTypes = {
  visible: _propTypes.bool.isRequired,
  onFade: _propTypes.func
};
var _default = Fader; // Function from David Walsh: http://davidwalsh.name/css-animation-callback

exports["default"] = _default;

var whichTransitionEndEvent = function whichTransitionEndEvent() {
  var t;
  var el = document.createElement('fakeelement');
  var animations = {
    'transition': 'transitionend',
    'OTransition': 'oTransitionEnd',
    'MozTransition': 'transitionend',
    'WebkitTransition': 'webkitTransitionEnd'
  };

  for (t in animations) {
    if (el.style[t] !== undefined) {
      return animations[t];
    }
  }
};